import { createRouter, createWebHashHistory } from 'vue-router'
import LoginView from '@/views/login/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HomeView.vue'),
    redirect: '/main',
    children: [
      {
        path: '/main',
        name: 'main',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/MainView.vue')
      },
    ]
  },
  {
    path: '/openView',
    name: 'openView',
    meta: {
      isShow: true,
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/openView.vue')
  },
  {
    path: '/color-preview',
    name: 'color-preview',
    meta: {
      isShow: true,
    },
    component: () => import(/* webpackChunkName: "color-preview" */ '@/views/ColorPreview.vue')
  },
  // 普通用户的router
  {
    path: '/user-home',
    name: 'user-home',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HomeView.vue'),
    redirect: '/user-main',
    children: [
      //主页面
      {
        path: '/user-main',
        name: 'user-main',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/MainView.vue')
      },
      {
        path: '/user-main-a',
        name: 'user-main-a',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/openView.vue')
      },
      // 协议管理——污染物代码
      {
        path: '/factor-management',
        name: 'factor-management',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/facterManager.vue'),
      },
      // 站点管理——站点列表
      {
        path: '/site-siteList',
        name: 'site-siteList',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/siteManagement.vue'),
      },
      // 站点管理——地图列表
      {
        path: '/site-gis',
        name: 'site-gis',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/gis.vue'),
      },
      // 数据分析——历史数据
      {
        path: '/data-history',
        name: 'data-history',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataHistory.vue'),
      },
      // 数据分析——数据图表
      {
        path: '/data-Charts',
        name: 'data-Charts',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataCharts.vue'),
      },
      // 数据分析——日志
      {
        path: '/data-rz',
        name: 'data-rz',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataRZ.vue'),
      },
      // 数据分析——状态
      {
        path: '/data-zt',
        name: 'data-zt',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataZT.vue'),
      },
      // 数据分析——报警
      {
        path: '/data-bj',
        name: 'data-bj',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataBj.vue'),
      },
      // 数据分析——报警
      {
        path: '/data-warn',
        name: 'data-warn',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataWarn.vue'),
      },
      // 数据分析——日报表
      {
        path: '/report-day',
        name: 'report-day',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/reportDay.vue'),
      },
      // 数据分析——周报表
      {
        path: '/report-week',
        name: 'report-week',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/reportDay.vue'),
      },
      // 数据分析——月报表
      {
        path: '/report-moon',
        name: 'report-moon',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/reportDay.vue'),
      },
      // 日志中心 ——短信
      {
        path: '/log-msg',
        name: 'log-msg',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/logMsg.vue'),
      },
      // 日志中心 ——废水参数信息
      {
        path: '/log-wasteWater-parameter',
        name: 'log-wasteWater-parameter',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/logWasteWater.vue'),
      },
      // 系统设置——修改密码
      {
        path: '/updatePwd',
        name: 'updatePwd',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/updatePwd.vue'),
      },
      // 系统设置——修改数据页面显示
      {
        path: '/dataUI-setting',
        name: 'dataUI-setting',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/dataUISetting.vue'),
      },
      // 系统设置——给用户分配设备
      {
        path: '/user-setting',
        name: 'user-setting',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/UserSettingView.vue'),
      }
    ]
  },
  // 附属用户的router
  {
    path: '/affiliatedUser-home',
    name: 'affiliatedUser-home',
    component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/HomeView.vue'),
    redirect: '/affiliatedUser-main',
    children: [
      //主页面
      {
        path: '/affiliatedUser-main',
        name: 'affiliatedUser-main',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/MainView.vue')
      },
      {
        path: '/affiliatedUser-data-history',
        name: 'affiliatedUser-data-history',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/dataHistory.vue')
      },
      {
        path: '/affiliatedUser-data-warn',
        name: 'affiliatedUser-data-warn',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/dataWarn.vue')
      },
      {
        path: '/affiliatedUser-log-msg',
        name: 'affiliatedUser-log-msg',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/logMsg.vue')
      },
      {
        path: '/affiliatedUser-wasteWater-parameter',
        name: 'affiliatedUser-wasteWater-parameter',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/logWasteWater.vue')
      },
      {
        path: '/affiliatedUser-updatePwd',
        name: 'affiliatedUser-updatePwd',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/updatePwd.vue')
      },
      {
        path: '/affiliatedUser-dataUI-setting',
        name: 'affiliatedUser-dataUI-setting',
        meta: {
          isShow: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '@/views/affiliatedUser/dataUISetting.vue')
      },
    ]
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// 白名单路由


router.beforeEach(async (to, from, next) => {
  if (to.path === '/' || to.path === '/openView' || to.path === '/color-preview') {
    next()
  } else {
    const userid = sessionStorage.getItem("LoginUserId");

    if (!userid) {
      next('/')
    } else {
      next()
    }
  }

})
export default router
